module.exports = __webpack_public_path__ + "assets/img/tx30g_4.ccedb5b7.jpg";